import { styled } from "styled-components";

export const MyInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 18px;
`;
